export const serializeParams = (paramList: { levelName: string; unitId: number; unitName: string; courseId: number; isFromUnitIndex?: boolean }) => {
  return Object.keys(paramList).reduce((prev, acc) => (prev += `${acc}=${paramList[acc]}&`), '');
}


// WEBPACK FOOTER //
// ./ts/app/shared/helpers/serialize-params.ts